import { render, staticRenderFns } from "./ShiftsNum.vue?vue&type=template&id=2d46e9f8&scoped=true&"
import script from "./ShiftsNum.vue?vue&type=script&lang=js&"
export * from "./ShiftsNum.vue?vue&type=script&lang=js&"
import style0 from "./ShiftsNum.vue?vue&type=style&index=0&id=2d46e9f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d46e9f8",
  null
  
)

export default component.exports